import { get } from 'utils/lodash';

export const formatDeleteConfirmationPayload = data => ({
  userId: get(data, 'userId', ''),
  billAccountNumber: get(data, 'billAccountNumber', ''),
  payeeCode: get(data, 'payeeCode', ''),
  billType: get(data, 'billType'),
});
